export function getConfig() {
  return {
    SESSION_ID_KEY: 'SESSION_ID',
    ACCESS_BASE_API: '/api/v1/access',
    ACCESS_ADMIN_BASE_API: '/api/v1/access-admin',
    RAINBOW_BASE_API: '/api/v1/rainbow',
    ASSETS_BASE_API: '/ui-assets',
    AUTH_TOKEN: 'IGN_AUTH',
    CONTROLLED_MODE_AUTH_TOKEN: 'authToken',
    CONTROLLED_MODE_KEY: 'CONTROLLED_MODE',
    ACCESS_CONFIGS_URL: '/access/configurations',
    DEFAULT_LANG: 'en',
    SUPPORTED_LANGUAGES: ['en', 'he'],
    DEFAULT_COLOR_SCHEMA: 'igentifyBrand',
    COLOR_SCHEMA_KEY: 'colorSchema',
    ORGANIZATION_LOGO_KEY: 'organizationLogo',
    ORGANIZATION_NAME_KEY: 'organizationName',
    ORGANIZATION: 'organization',
    LOGIN_PATH_KEY: 'loginPath',
    REGISTER_PATH_KEY: 'registerPath',
    VIDEO_SEEKING_MODE: 'videoSeekingMode',
  };
}

export const configs = getConfig();
